import { createSelector } from 'reselect';
import BaInfoConstants from 'Shared/constants/BaInfo.constants';

const getBaInfo = state => state.BaInfo;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getUserGuidParam = createParameterSelector(params => params.userGuid);

export const getAllBaInfo = createSelector([getBaInfo], baInfo =>
  baInfo.get(BaInfoConstants.State.BA_INFO_BY_USER_SLUG)
);

export const getAllPendingAssessmentIdByUserSlug = createSelector([getBaInfo], baInfo =>
  baInfo.get(BaInfoConstants.State.PENDING_BA_ASSESSMENT_ID_BY_USER_SLUG)
);

export const getBaInfoByUserId = createSelector([getAllBaInfo, getUserGuidParam], (baInfo, id) =>
  baInfo.get(id)?.toJS()
);

export const getPendingAssessmentIdByUserSlug = createSelector(
  [getAllPendingAssessmentIdByUserSlug, getUserGuidParam],
  (pendingBaAssessmentIds, id) => pendingBaAssessmentIds.get(id)
);
